export enum RunView {
  Current = 'current',
  Completed = 'completed',
}
